export const GHG_EMISSION_ACTIVITIES_INIT = {
	emissionActivityOperation: false,
	scope: [
		{
			scope: 1,
			emissionCategory: false,
			emissionSource: false,
			activityData: false,
		},
		{
			scope: 2,
			emissionCategory: false,
			emissionSource: false,
			activityData: false,
		},
	],
	emissionFactor: false,
};

export const DECARBONIZATION_TARGET_INIT = {
	SBTITemperatureAlignment: false,
	baseYear: false,
	targetYear: false,
	targetType: false,
	targetReductionRate: false,
	notListed: false,
	other: false,
};

export const ASSET_DETILED = {
	assetType: '',
	assetName: '',
	assetSpecifications: {
		brand: false,
		model: false,
		installationYear: false,
		capacity: false,
		noOfUnit: false,
		opHr: false,
		loadingRate: false,
		cop: false,
		efficiency: false,
		energySource: false,
		other: false,
	},
};

export const ENERGY_ASSET_PROFILE_INIT = {
	assetDetailed: [{}],
};
